import React, {Component} from 'react'

class SelectEngineBariki extends Component {
  handleChange = (e) => {
    this.props.actions.changeSelectEngineBariki({
      selectEngineBariki: e.target.value,
    })
  }

  render() {
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.LIST_SEARCH.HORSEPOWER.TITLE}</h3>
        <p>
          <input
            className='input size-m'
            placeholder={TRUCKERS.LANG.ITEM.LIST_SEARCH.HORSEPOWER.PLACEHOLDER}
            value={this.props.selectEngineBariki}
            onChange={this.handleChange}
          />
          {TRUCKERS.LANG.ITEM.LIST_SEARCH.HORSEPOWER.UNIT}
        </p>
      </div>
    )
  }
}
export default SelectEngineBariki
